export default "__VITE_ASSET__VcgRbT7Q__"